var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c("div", { staticClass: "main-content" }, [
        _c("div", { staticClass: "form-column" }, [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_LoginEnterpriseWechat")))
          ]),
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.loginSuccess,
                expression: "!loginSuccess"
              }
            ],
            staticStyle: { width: "240px", height: "300px", cursor: "pointer" },
            attrs: { src: _vm.selectedRow.qrcodeUrl }
          }),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.loginSuccess,
                  expression: "loginSuccess"
                }
              ],
              staticStyle: {
                width: "240px",
                height: "300px",
                "margin-bottom": "-17px",
                "padding-top": "120px",
                border: "1px solid #c3c3c3",
                cursor: "pointer"
              }
            },
            [
              _c("span", { staticStyle: { "margin-left": "30px" } }, [
                _vm._v(_vm._s(_vm.loginSuccessTip))
              ])
            ]
          ),
          _c(
            "span",
            { staticStyle: { color: "#1890ff", "margin-left": "10px" } },
            [_vm._v(_vm._s(_vm.captchaUsingTip))]
          ),
          _c("br"),
          _c("span", [
            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_LoginEnterpriseWechatTip")))
          ]),
          _c("br"),
          _c("div", {
            staticStyle: {
              "padding-top": "6px",
              width: "100%",
              "border-bottom": "1px solid black"
            }
          }),
          _c(
            "span",
            { staticClass: "title", staticStyle: { "padding-top": "10px" } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_RpaAccountSummary")))]
          ),
          _c(
            "div",
            {
              staticClass: "grid-wrapper",
              staticStyle: {
                width: "1000px",
                "min-height": "210px",
                "padding-bottom": "0",
                "margin-top": "-10px"
              }
            },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_RpaAccountSummaryTip")))
              ]),
              _c(
                "cargo-left-right-resize",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    "show-right": _vm.dgCompany.show,
                    "left-style": { "min-width": "30%" },
                    "right-style": { "min-width": "70%" }
                  }
                },
                [
                  _c("div", { attrs: { slot: "left" }, slot: "left" }, [
                    _c(
                      "div",
                      {
                        staticClass: "app-main-inner-row row-grid-dialog",
                        staticStyle: { "min-height": "210px", padding: "0" }
                      },
                      [
                        _c("cargo-ag-grid", {
                          staticStyle: { width: "100%", "min-height": "300px" },
                          attrs: {
                            "grid-options": _vm.dgGroup.gridOptions,
                            "column-defs": _vm.dgGroup.columnDefs,
                            "row-data": _vm.rpaAccounts
                          },
                          on: { gridReady: _vm.onGridReady_dgGroup }
                        })
                      ],
                      1
                    )
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "app-main-inner-row row-grid-dialog",
                      staticStyle: {
                        height: "100%",
                        "min-height": "300px",
                        padding: "0"
                      },
                      attrs: { slot: "right" },
                      slot: "right"
                    },
                    [
                      _c("cargo-ag-grid", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "grid-options": _vm.dgCompany.gridOptions,
                          "column-defs": _vm.dgCompany.columnDefs,
                          "row-data": _vm.dgCompanyRowData
                        },
                        on: { gridReady: _vm.onGridReady_dgCompany }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ])
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "verification-code-dialog",
          attrs: {
            "custom-class": "",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "show-close": false,
            visible: _vm.verificationCodeDialog.visible,
            title: _vm.$t("CargoMsg.Cargo_PleaseInputVerificationCode"),
            width: "335px"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.verificationCodeDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            {
              staticStyle: {
                "font-size": "14px",
                "margin-left": "12px",
                "margin-right": "16px"
              },
              attrs: { "label-width": "0", "label-position": "left" },
              nativeOn: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c("el-form-item", [
                _c("span", [_vm._v(_vm._s(_vm.verificationCodeTip))])
              ]),
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    attrs: { no: "verificationCode" },
                    model: {
                      value: _vm.verificationCodeDialog.verificationCode,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.verificationCodeDialog,
                          "verificationCode",
                          $$v
                        )
                      },
                      expression: "verificationCodeDialog.verificationCode"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function($event) {
                      _vm.verificationCodeDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.saveVerificationCodeHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmR")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }